<template>
  <div class="options-row row BoxStyle" :class="[{'RemoveControl':clicked!==-1}]">
    <div class="col-12 text-center HeaderPositionQuestion">
      <div class="arrow" :class="['fade', {'fade-in': closeTextEnable}]"></div>
      <p :class="['mb-0 pa-5 close-text fade  mt-3   ', {'fade-in': closeTextEnable}]">
        Hey, you can always
        click here
        if you are unsure about the answer.
      </p>

      <h1 id="questionTitle" class="redText main-title" :class="['fade', {'fade-in':question}]">
        Find the character for ‘month’
        <img
          class="x-btn"
          style="cursor: pointer;float: right"
          @mouseenter="buttonHover"
          :src="require(`@/assets/img/Question.png`)"
          alt
          @click="closeClick"
        />
      </h1>
    </div>
    <div
      class="col-4 mx-2 mt-3 fade options image"
      style="transition: all 0.6s ease!important;"
      v-for="(i, index) in list"
      :key="i"
      :style="{border:clicked !== -1 || ShowMe?'unset':''}"
      :class="[{'fade-in':images,'active': active === i,
                                'RemoveAnimation':clicked !== -1 &&  clicked !== index ,
                  'clicked hinted': clicked === index && ShowMe!== true,
                  'move-right': ( ( (clicked===2 && index===1) || (clicked===1 && index===2 ) || (clicked===0 && index===2 ) ) && ShowMe!== true ),
                  'move-left': ( ( (clicked===2 && index===0) || (clicked===1 && index===0 ) || (clicked===0 && index===1 ) ) && ShowMe!== true),
                  },
                   `index-${list.length===1?1:index}`,
                    `${ControlToShow(index)}`,
                   `l3q2option-${i}`]"
    >
      <template v-if="index===1">
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
        />
      </template>
      <template v-else>
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
        />
      </template>
      <template v-if="i===2">
        <div
          class="wrong"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            left: '-13%',
            top: '53%',
          }"
        ></div>
      </template>
      <template v-if="i===3">
        <div
          class="wrong"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            left: '-7%',
            top: '35%' ,
            width: '70px',
            height: '70px'
          }"
        ></div>
      </template>
      <template v-if="i===2 && pregress">
        <img class="cloud1" src="./images/cloud-01.png" alt="pic">
        <img class="cloud2" src="./images/cloud-01.png" alt="pic">
        <img class="moon" src="./images/moon-01.png" alt="pic">
      </template>
      <template v-if="i===3 && pregress">
        <img alt="pic" src="./images/horisontal.png" class="horisontal1" />
        <img alt="pic" src="./images/horisontal.png" class="horisontal2" />
        <img alt="pic" src="./images/horisontal.png" class="horisontal3" />
        <img alt="pic" src="./images/horisontal.png" class="horisontal4" />
        <img alt="pic" src="./images/large.png" class="large-left" />
        <img alt="pic" src="./images/large.png" class="large-right" />
        <img alt="pic" src="./images/large2.png" class="large-curved" />
        <img alt="pic" src="./images/small.png" class="small" />
      </template>
    </div>

    <div
      style="bottom: 10px;position: absolute;padding: 10px "
      :class="{'fade hints-row': true, 'fade-in':textBoxEnable===1, 'fade-out':textBoxEnable===2 }"
    >
      <div
        class="col-12 p-0"
        v-for="(i) in list"
        :key="i"
        :class="[{'active': active === i, }]"
        style="padding: 0"
      >
        <div v-if="textBox[i] !== ''" class="pt-5">
          <div class="pt-5 mt-4">
            <div v-if="textBox[i] !== ''" class="text-box py-3 px-3 align-center text-center">
              <p class="mb-0 mr-3">{{textBox[i]}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question2",

  data() {
    return {
      pregress: false,
      wrongShow: false,
      ShowMe: false,
      textBoxEnable: 0,
      closeTextEnable: false,
      images: false,
      question: false,
      active: 0,
      clicked: -1,
      list: [1, 2, 3],
      textBox: {
        1: "",
        2: "",
        3: ""
      },
      hints: {
        1: "",
        2: `Great job for finding this symbol that shapes like a crescent moon! However, there are usually clouds hovering over the moon when we look up the night sky. Maybe try to find another character that resembles this combination?`,
        3: `The character we are looking for resembles a crescent moon. Let’s curve the side a little more and see which other characters look for like it?`
      },
      hinted: false,
      mouse_over: "/sound/new mouse over.wav",
    };
  },
  props: {
    playSound: {
      type: Function
    },
    shuffle: {
      type: Function
    },
    finish: {
      type: Function
    },
    buttonHover: {
      type: Function
    }
  },
  mounted() {
    this.images = false;
    this.list = this.shuffle(this.list);

    this.playSound(require("./sounds/3-1.wav"));
    setTimeout(() => {
      this.question = true;

      setTimeout(() => {
        this.images = true;
      }, 2000);
      setTimeout(() => {
        this.closeTextEnable = true;
        this.playSound("/sound/textbox shows.wav");
        setTimeout(() => {
          this.closeTextEnable = false;
        }, 5000);
      }, 3000);
    }, 500);
  },
  methods: {
    closeClick() {
      if (this.ShowMe === true || this.pregress === true) {
        return;
      }
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.pregress = true;
      this.ShowMe = false;
      this.playSound("/sound/button click.wav").then(() => {
        setTimeout(() => {
          this.textBox = {
            1: "",
            2: "",
            3: ""
          };
          setTimeout(() => {
            this.clicked = this.list.indexOf(2);
            this.textBox[2] = JSON.parse(JSON.stringify(this.hints[2]));
            this.hinted = true;
            this.playSound("/sound/textbox shows.wav");
            this.makeSetTimeout();
            this.playSound(require("./sounds/3-11.wav")).then(() => {
              setTimeout(() => {
                this.playSound("/sound/textbox shows.wav");
                setTimeout(()=>{
                  this.clicked = this.list.indexOf(3);
                  this.textBox[2] = "";
                  this.textBox[3] = JSON.parse(JSON.stringify(this.hints[3]));
                  this.mistake2motion();
                  this.playSound(require("./sounds/3-12.wav")).then(() => {
                    setTimeout(() => {
                      this.playSound("/sound/correct answer.wav");
                      this.textBox = {
                        1: "",
                        2: "",
                        3: ""
                      };
                      this.list = [3, 1, 2];
                      this.clicked = this.list.indexOf(1);
  
                      setTimeout(() => {
                        this.hinted = false;
                        this.textBoxEnable = 0;
                        this.list = this.shuffle(this.list);
                        this.pregress = false;
                        this.active = 0;
                        this.ShowMe = false;
                        this.clicked = -1;
                      }, 3000);
                    }, 5000);
                  });
                },50)
              }, 4000);
            });

            this.textBoxEnable = 1;
          }, 50);
        });
      }, 1000);
    },
    mouseleave() {
      this.active = 0;
    },
    mouseover(i) {
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.active = i;
      this.playSound(this.mouse_over);
    },
    ControlToShow(i) {
      if (this.ShowMe) {
        if (i === 0) {
          return "RemoveAnimation";
        }
        if (i === 2) {
          return "RemoveAnimation";
        }
      } else {
        return "Scale1";
      }
      return "";
    },
    showWrong() {
      setTimeout(() => {
        this.wrongShow = true;
      }, 1900);
      setTimeout(() => {
        this.wrongShow = false;
      }, 6000);
    },
    closeTextBox() {
      this.textBoxEnable = 2;
      this.hinted = false;
      setTimeout(() => {
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        this.textBoxEnable = 0;
        this.clicked = -1;
      }, 1000);
    },
    makeSetTimeout() {
      const cloud1 = document.querySelector('.cloud1')
      const cloud2 = document.querySelector('.cloud2')
      const moon = document.querySelector('.moon')
      setTimeout(() => {
        moon.classList.add('opacity-off')
      }, 2500)
      setTimeout(() => {
        cloud1.classList.add('cloud1-in')
      }, 4000)
      setTimeout(() => {
        cloud2.classList.add('cloud2-in')
      }, 5500)
    },
    mistake2motion() {
      const horisontal1 = document.querySelector('.horisontal1')
      const horisontal2 = document.querySelector('.horisontal2')
      const horisontal3 = document.querySelector('.horisontal3')
      const horisontal4 = document.querySelector('.horisontal4')
      const largeLeft = document.querySelector('.large-left')
      const largeRight = document.querySelector('.large-right')
      const largeCurved = document.querySelector('.large-curved')
      const small = document.querySelector('.small')
      setTimeout(() => {
        horisontal1.style = "opacity: 1; transition: all 1s ease;"
        horisontal2.style = "opacity: 1; transition: all 1s ease;"
        horisontal3.style = "opacity: 1; transition: all 1s ease;"
        horisontal4.style = "opacity: 1; transition: all 1s ease;"
        largeLeft.style = "opacity: 1; transition: all 1s ease;"
        largeRight.style = "opacity: 1; transition: all 1s ease;"
      }, 1500)
      setTimeout(() => {
        largeLeft.style = "opacity: 0; transition: all 1s ease;"
        largeCurved.style = "opacity: 1; transition: all 1s ease;"
      }, 3300)
      setTimeout(() => {
        horisontal4.style = "opacity: 0; transition: all 1s ease;"
      }, 5500)
      setTimeout(() => {
        small.style = "opacity: 1; transition: all 1s ease;"
      }, 7500)
    },
    successFinish() {
      setTimeout(() => {
        this.pregress = false;
        this.closeTextBox();
      }, 3000);
      this.playSound("/sound/correct answer.wav");
      this.finish();
    },
    finishMition(velocity) {
      setTimeout(() => {
        this.clicked = -1;
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        this.pregress = false;
      }, velocity);
    },
    imgClick(i, index) {
      if (this.clicked !== -1 || this.ShowMe || this.pregress === true) {
        return;
      }
      this.pregress = true;
      setTimeout(() => {
        this.hinted = false;
        this.clicked = index;
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        if (i === 1) {
          this.successFinish();
        } else {
          this.playSound("/sound/highlight.wav");
          this.clicked = index;
          if (i === 2) {
            this.textBox[i] = this.hints[i];
            this.makeSetTimeout();
            this.playSound(require("./sounds/3-11.wav")).then(() => {
              this.finishMition(1800);
            })
          } else {
            this.textBox[i] = this.hints[i];
            this.mistake2motion();
            this.playSound(require("./sounds/3-12.wav")).then(() => {
              this.finishMition(1800);
            });
          }
          setTimeout(() => {
            this.playSound("/sound/textbox shows.wav");
            this.textBoxEnable = 1;
          }, 1000);
          setTimeout(() => {}, 1000);
        }
      }, 200);
    }
  }
};
</script>

<style lang="scss">
.l3q2option-2 {
  .cloud1{
    z-index: 1;
    position: absolute;
    top: 22%;
    left: 800%;
    transition: all 1s ease;
    width: 52%;
  }
  .cloud1-in{
    left: 80%;
    transition: all 2s ease;
  }
  .cloud2{
    position: absolute;
    top: 43%;
    left: 800%;
    transition: all 1s ease;
    width: 52%;
    transform: rotate(7deg);
    z-index: 1;
  }
  .cloud2-in{
    left: 80%;
    transition: all 2s ease;
  }
  .moon{
    position: absolute;
    top: 6%;
    left: 61%;
    opacity: 0;
    transition: all 1s ease;
    width: 64%;
    transform: rotate(-16deg);
  }
  .red-base{
    position: absolute;
    top: 14%;
    left: 90%;
    opacity: 0;
    transition: all 1s ease;
    width: 24%;
    height: 72%;
    z-index: 2;
  }
  .opacity-off{
    opacity: 1;
    transition: all 1s ease;
  }
  .v-image {
    left: 0;
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: left 2s;
      left: -50%;
    }
  }
}

@keyframes width_up {
  0% {
    width: 57%;
    left: 70%;
  }
  100% {
    width: 100%;
    left: 48.9%;
  }
}

.l3q2option-3 {
  .horisontal1{
    opacity: 0;
    position: absolute;
    top: 19%;
    left: 82%;
    transition: all 1s ease;
    width: 46%;
    height: 8%;
  }
  .horisontal2{
    opacity: 0;
    position: absolute;
    top: 40%;
    left: 89%;
    transition: all 1s ease;
    width: 32%;
    height: 8%;
  }
  .horisontal3{
    opacity: 0;
    position: absolute;
    top: 61%;
    left: 88%;
    transition: all 1s ease;
    width: 34%;
    height: 8%;
  }
  .horisontal4{
    opacity: 0;
    position: absolute;
    top: 82%;
    left: 88%;
    transition: all 1s ease;
    width: 34%;
    height: 8%;
  }
  .large-left{
    opacity: 0;
    position: absolute;
    top: 17%;
    left: 82%;
    transition: all 1s ease;
    width: 8%;
  }
  .large-right{
    opacity: 0;
    position: absolute;
    top: 17%;
    left: 121%;
    transition: all 1s ease;
    width: 8%;
  }
  .large-curved{
    opacity: 0;
    position: absolute;
    top: 16%;
    left: 71%;
    transition: all 1s ease;
    width: 19%;
  }
  .small{
    opacity: 0;
    position: absolute;
    top: 81%;
    left: 111%;
    width: 18%;
    transform: rotate(45deg);
    transition: all 1s ease;
  }
  .v-image {
    left: unset;
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: all 2s;
      left: -50%;
      /*opacity: 0;*/
    }
  }
}

@keyframes transformUp {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-22.5deg);
    left: 68.2%;
  }
}

@keyframes transformDown {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(22.5deg);
  }
}
</style>